import { useState } from 'react';

/**
 * Hook zarządzający logiką mapki otworów (widok z góry).
 * Tryb dodawania otworów z mapki i zaznaczania do przekroju.
 */
export function useBoreholeMap({ boreholes, setBoreholes, addBoreholeFromMap }) {
  const [addBoreholeFromMapMode, setAddBoreholeFromMapMode] = useState(false);
  const [selectBoreholeForProfileMode, setSelectBoreholeForProfileMode] = useState(false);
  const [selectedBoreholesForProfile, setSelectedBoreholesForProfile] = useState([]);

  const handleMapClick = (e) => {
    if (!addBoreholeFromMapMode) return;

    const svg = e.currentTarget;
    const rect = svg.getBoundingClientRect();
    const svgX = e.clientX - rect.left;
    const svgY = e.clientY - rect.top;

    // Konwersja współrzędnych SVG na współrzędne mapki
    // SVG: X: 50-550 (skalowanie *5), Y: 350-50 (skalowanie *3, odwrócone)
    const x = Math.max(0, Math.min(100, (svgX - 50) / 5));
    const y = Math.max(0, Math.min(100, (350 - svgY) / 3));

    addBoreholeFromMap(parseFloat(x.toFixed(1)), parseFloat(y.toFixed(1)));
  };

  const handleBoreholeSelectOnMap = (boreholeId) => {
    if (!selectBoreholeForProfileMode) return;

    setSelectedBoreholesForProfile(prev => {
      if (prev.includes(boreholeId)) {
        return prev.filter(id => id !== boreholeId);
      } else {
        return [...prev, boreholeId];
      }
    });
  };

  const createProfileFromSelected = () => {
    if (selectedBoreholesForProfile.length < 2) {
      alert('Musisz zaznaczyć co najmniej 2 otwory, aby utworzyć przekrój!');
      return;
    }

    const selectedBoreholes = selectedBoreholesForProfile
      .map(id => boreholes.find(b => b.id === id))
      .filter(b => b !== undefined);

    let cumulativeDistance = 0;
    const boreholesWithDistance = selectedBoreholes.map((borehole, index) => {
      if (index === 0) {
        return { ...borehole, distance: 0 };
      }

      const prevBorehole = selectedBoreholes[index - 1];
      const dx = borehole.x - prevBorehole.x;
      const dy = borehole.y - prevBorehole.y;
      const distance = Math.sqrt(dx * dx + dy * dy);
      cumulativeDistance += distance;

      return { ...borehole, distance: cumulativeDistance };
    });

    setBoreholes(boreholesWithDistance);
    setSelectedBoreholesForProfile([]);
    setSelectBoreholeForProfileMode(false);

    alert(`Utworzono przekrój z ${boreholesWithDistance.length} otworów!`);
  };

  return {
    addBoreholeFromMapMode, setAddBoreholeFromMapMode,
    selectBoreholeForProfileMode, setSelectBoreholeForProfileMode,
    selectedBoreholesForProfile, setSelectedBoreholesForProfile,
    handleMapClick,
    handleBoreholeSelectOnMap,
    createProfileFromSelected,
  };
}
